import { ElementTypeDTO } from '@/model';
import {
  ArrowBigRightDash,
  Clock,
  GalleryVerticalEnd,
  GitCommitHorizontal,
  GitCommitVertical,
  Hourglass,
  Image,
  LetterText,
  LucideIcon,
  Rss,
} from 'lucide-react';

export const layoutElementIconMap = new Map<ElementTypeDTO, LucideIcon>([
  [ElementTypeDTO.CLOCK, Clock],
  [ElementTypeDTO.IMAGE_DISPLAY_NORMAL, Image],
  [ElementTypeDTO.TEXT_CONSTANT, LetterText],
  [ElementTypeDTO.TIME_COUNT_DOWN, Hourglass],
  [ElementTypeDTO.STOP_NAME, GitCommitVertical],
  [ElementTypeDTO.TIMETABLE, GalleryVerticalEnd],
  [ElementTypeDTO.ANNOUNCEMENT, Rss],
  [ElementTypeDTO.PAGER, ArrowBigRightDash],
  [ElementTypeDTO.STOP_DIRECTION_NAME, GitCommitHorizontal],
  [ElementTypeDTO.PAGE_COUNTER, GalleryVerticalEnd],
]);

export interface AddElementPaletteItem {
  id: string;
  elementType: ElementTypeDTO;
  labelKey: string;
  onClick: () => void;
}

export const buildAddElementPalette = (
  openTextModal: (elementType: ElementTypeDTO) => void,
  setImageModalConfig: (config: { open: boolean; elementType: ElementTypeDTO }) => void,
  setIsDynamicTimeTableModalOpen: (open: boolean) => void,
  initializeAnnouncementElement: () => void,
): AddElementPaletteItem[] => [
  {
    id: 'clock',
    elementType: ElementTypeDTO.CLOCK,
    labelKey: 'layout-editor.element.clock',
    onClick: () => openTextModal(ElementTypeDTO.CLOCK),
  },
  {
    id: 'image',
    elementType: ElementTypeDTO.IMAGE_DISPLAY_NORMAL,
    labelKey: 'layout-editor.element.image',
    onClick: () =>
      setImageModalConfig({
        open: true,
        elementType: ElementTypeDTO.IMAGE_DISPLAY_NORMAL,
      }),
  },
  {
    id: 'text',
    elementType: ElementTypeDTO.TEXT_CONSTANT,
    labelKey: 'layout-editor.element.text',
    onClick: () => openTextModal(ElementTypeDTO.TEXT_CONSTANT),
  },
  {
    id: 'stop-name',
    elementType: ElementTypeDTO.STOP_NAME,
    labelKey: 'layout-editor.element.stop-name',
    onClick: () => openTextModal(ElementTypeDTO.STOP_NAME),
  },
  {
    id: 'announcement',
    elementType: ElementTypeDTO.ANNOUNCEMENT,
    labelKey: 'layout-editor.element.announcement-area',
    onClick: initializeAnnouncementElement,
  },
  {
    id: 'pager',
    elementType: ElementTypeDTO.PAGER,
    labelKey: 'layout-editor.element.navigation-button',
    onClick: () => setImageModalConfig({ open: true, elementType: ElementTypeDTO.PAGER }),
  },
  {
    id: 'stop-direction-name',
    elementType: ElementTypeDTO.STOP_DIRECTION_NAME,
    labelKey: 'layout-editor.element.platform-direction',
    onClick: () => openTextModal(ElementTypeDTO.STOP_DIRECTION_NAME),
  },
  {
    id: 'dynamic-timetable',
    elementType: ElementTypeDTO.TIMETABLE,
    labelKey: 'layout-editor.element.dynamic-timetable',
    onClick: () => setIsDynamicTimeTableModalOpen(true),
  },
  {
    id: 'page-counter',
    elementType: ElementTypeDTO.PAGE_COUNTER,
    labelKey: 'layout-editor.element.page-counter',
    onClick: () => openTextModal(ElementTypeDTO.PAGE_COUNTER),
  },
];
